import { render, staticRenderFns } from "./PersonalData.vue?vue&type=template&id=e91f8432&scoped=true"
import script from "./PersonalData.vue?vue&type=script&lang=js"
export * from "./PersonalData.vue?vue&type=script&lang=js"
import style0 from "./PersonalData.vue?vue&type=style&index=0&id=e91f8432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e91f8432",
  null
  
)

export default component.exports